<template>
  <div class="privacy-policy">
    <h1 class="page-title">隱私權政策</h1>
    <p>本隱私權政策（以下簡稱「政策」）旨在說明台灣聯通官方網站（以下簡稱「本網站」）如何蒐集、使用、分享及保護您的個人資料。當您使用本網站或與本網站互動時，即表示您同意本政策的內容。</p>

    <p>一、我們蒐集的資訊<br>
      我們可能會蒐集以下類型的資訊：</p>
    <ul>
      <li>個人識別資料： 包括您的姓名、電子郵件地址、聯絡電話及其他與您個人身份有關的資訊。</li>
      <li>使用資訊： 當您瀏覽本網站時，我們可能會自動收集有關您使用本網站的資訊，例如 IP 位址、瀏覽器類型、操作系統、瀏覽行為等。</li>
      <li>Cookies 資訊： 本網站可能會使用 cookies 技術來增進您的瀏覽體驗，您可以透過瀏覽器設定管理或拒絕 cookies。</li>
    </ul>

    <p>二、我們如何使用您的資訊<br>
      我們蒐集的資訊可能會用於以下目的：</p>
    <ul>
      <li>提供服務： 用於處理您的請求或訂單，並提供您所需的資訊或服務。</li>
      <li>改善網站： 分析使用數據，以便優化我們的網站功能及使用者體驗。</li>
      <li>行銷與推廣： 向您提供相關的促銷資訊或服務更新（若您選擇接收）。</li>
    </ul>

    <p>三、資訊的分享<br>
      我們承諾不會向第三方出售或租賃您的個人資料。除非為了提供您所要求的服務，或依法令要求，我們才會在以下情況下分享您的資訊：</p>
    <ul>
      <li>服務供應商： 我們可能與經審查的第三方服務供應商合作，協助我們運營網站或提供服務。</li>
      <li>法律要求： 當我們有合理理由相信有法律義務時，我們將會依照法律要求分享您的資訊。</li>
    </ul>

    <p>四、資訊的安全性<br>
      我們採取適當的技術及組織性措施，保護您的個人資料不受未經授權的存取、使用或洩露。然而，網路傳輸並非完全安全，請注意您在網路上分享個人資料時應謹慎。</p>

    <p>五、您的權利<br>
      您有權隨時查詢、更正或刪除我們所持有的您的個人資料。如果您有任何隱私權問題，請隨時與我們聯繫。</p>

    <p>六、政策的修改<br>
      我們保留隨時修改本政策的權利。政策更新後，我們會將修訂後的版本發布於本網站，建議您定期查看此政策的變更。</p>

    <p>聯絡我們<br>
      如果您對本政策有任何疑問或需要進一步了解，請通過以下方式聯繫我們：</p>

  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
};
</script>

<style scoped>
.privacy-policy {
  max-width: 1416px;
  margin: 0 auto;
  /* padding: 40px 20px; */
  padding: 0px;
  /* color: #333; */
  margin-bottom: 160px;

}

.page-title {
  /* font-size: 2rem; */
  margin-bottom: 40px;
}

p,
li {

  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

ul {
  padding-left: 0;
  list-style-type: none;
}

ul li {
  /* padding-left: 20px; */
}

/* Responsive design */
@media (max-width: 560px) {
  .privacy-policy {
    width: 343px;
    /* padding: 20px; */
    margin-bottom: 80px;
  }



  p,
  li {
    /* //styleName: md/regular; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }
}
</style>